/* eslint-disable no-dupe-keys */
import { Box, Typography, Button, Tooltip, TextField, InputAdornment } from '@mui/material'
import React, { useState } from 'react'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SearchIcon from '@mui/icons-material/Search';
import ToggleSwitch from '../../../../components/ToggleSwitch/ToggleSwitch';
import AddReson from '../../../../components/Projects/AddReason'
import RadioBoxGroup from '../../../../components/RadioButtons/RadioBoxGroup'
import DefaultData from './DefaultData';
import GracePeriodData from './GracePeriodData';
const CalendarPage = () => {

  const [activeTab, setActiveTab] = useState('default');

  const [openAddCustom, setOpenAddCustom] = useState(false);
  const tabsBtnStyle = {
    fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
    padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
  }
  return (
    <>
      <Box sx={{
        overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
        maxWidth: '100%',
      }}>
        {/* Tabs */}
        <Box display="inline-flex"
          gap={1}
          mb={0}
          sx={{
            flexWrap: 'nowrap',
            minWidth: 'max-content',
          }}>
          <Button onClick={() => setActiveTab('default')} variant="contained" sx={{
            ...tabsBtnStyle,
            fontFamily: 'Manrope',
            height: '38px', borderRadius: '100px', backgroundColor: '#fff',
            backgroundColor: activeTab === 'default' ? '#0076FE' : '#fff', color: activeTab === 'default' ? '#fff' : '#64748B', border: activeTab === 'default' ? '1px solid #0076FE' : '1px solid #D0D5DD',
            fontWeight: 600, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
          }} >
            Calendar type
          </Button>
          <Button onClick={() => setActiveTab('complete')} variant="contained" sx={{
            ...tabsBtnStyle,
            fontFamily: 'Manrope',
            height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'complete' ? '#0076FE' : '#fff',
            color: activeTab === 'complete' ? '#fff' : '#64748B', border: activeTab === 'complete' ? '1px solid #0076FE' : '1px solid #D0D5DD', padding: '8px 16px',
            boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
          }}>Shift alerts
          </Button>

          <Button onClick={() => setActiveTab('edittab')} variant="contained" sx={{
            ...tabsBtnStyle,
            fontFamily: 'Manrope',
            height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'edittab' ? '#0076FE' : '#fff',
            color: activeTab === 'edittab' ? '#fff' : '#64748B', border: activeTab === 'edittab' ? '1px solid #0076FE' : '1px solid #D0D5DD', padding: '8px 16px',
            boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
          }}>Grace period
          </Button>
        </Box>
        {/* Tab Panel Content */}
      </Box>



      <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
        <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="default">
          <Box>
            <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
              Calendar type
              <Tooltip title="This setting controls what users can see in the calendar. Organization owners and managers will always have full access." arrow placement="top" alignContent="center">
                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                  <InfoOutlineIcon fontSize="small" />
                </button>
              </Tooltip>
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Setting the calendar to private allows users to see only their own shifts and time off. In contrast, a collaborative calendar enables all users to view the shifts and time off of every member within the organization.</Typography>
          </Box>

          <Box sx={{ m: '32px auto 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
            <Box>
              <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: '20px', color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                All users

                <Tooltip title="This setting applies to all users." arrow placement="top" alignContent="center">
                  <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                    <InfoOutlineIcon fontSize="small" />
                  </button>
                </Tooltip>
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box>
                <RadioBoxGroup
                  options={['Private', 'Collaborative']}
                  defaultValue="None"
                  row={true}
                />
              </Box>
            </Box>
          </Box>
        </CustomTabPanel>

        <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="complete">
          <Box>
            <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
              Shift alerts
              <Tooltip title="This setting applies to schedules and sends alerts when a user is late, misses, or abandons a shift." arrow placement="top" alignContent="center">
                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                  <InfoOutlineIcon fontSize="small" />
                </button>
              </Tooltip>
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Manage alert notifications for members and specify who should receive them.</Typography>
          </Box>

          <Box sx={{ m: '32px auto 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ddd', paddingBottom: '24px' , flexWrap: 'wrap' }}>
            <Box>
              <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                Global Setting
                <Tooltip title="Default for the organization. All current and future members will be assigned this setting." arrow placement="top" alignContent="center">
                  <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                    <InfoOutlineIcon fontSize="small" />
                  </button>
                </Tooltip>
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box>
                <RadioBoxGroup
                  options={['Both', 'Management', 'User', 'No one']}
                  defaultValue="None"
                  row={true}
                />
              </Box>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
            <Box sx={{ marginBottom: '10px' }}>
              <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
            </Box>
            <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
              placeholder="Search Member"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
              }}
            />
          </Box>

          <DefaultData />
        </CustomTabPanel>

        <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="edittab">
          <Box>
            <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
              Grace period
              <Tooltip title="This setting determines how much time can pass before a shift is marked as late." arrow placement="top" alignContent="center">
                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                  <InfoOutlineIcon fontSize="small" />
                </button>
              </Tooltip>
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Define the allowable delay before marking a shift as late.</Typography>
          </Box>

          <Box sx={{ m: '32px auto 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ddd', paddingBottom: '24px' ,flexWrap: 'wrap' }}>
            <Box>
              <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                Global Setting
                <Tooltip title="This is the default setting for the organization, applied to all current and future members." arrow placement="top" alignContent="center">
                  <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                    <InfoOutlineIcon fontSize="small" />
                  </button>
                </Tooltip>
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box>
                <RadioBoxGroup
                  options={['5 min', '10 min', '15 min', '20 min', '30 min']}
                  defaultValue="None"
                  row={true}
                />
              </Box>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
            <Box sx={{ marginBottom: '10px' }}>
              <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
            </Box>
            <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
              placeholder="Search Member"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
              }}
            />
          </Box>
          <GracePeriodData />
        </CustomTabPanel>

      </Box>

      <AddReson m open={openAddCustom} onClose={() => setOpenAddCustom(false)} />
    </>
  )
}
const CustomTabPanel = ({ value, index, children }) => {
  if (value !== index) return null;
  return <Box sx={{ padding: { xl: '16px 5px', lg: '15px 0', md: '15px 0', sm: '15px  0', sx: '15px 0' } }}>{children}</Box>;
};


export default CalendarPage
